<template>
  <div class="default-layout">
    <AppHeader :key="'app-header'" />
    <div class="container mx-auto py-4">
      <div class="grid grid-cols-12 gap-4">
        <slot name="aside">
          <ProfileInfo class="col-span-12 md:col-start-1 lg:col-end-5" />
        </slot>
        <slot name="default"></slot>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue'
import ProfileInfo from '~/components/ProfileInfo.client.vue'

export default defineComponent({
  components: { ProfileInfo },
})
</script>
